// Single source of truth for the "O mnie" page: the header submenu and the
// in-page anchor navigation are both built from these lists.

export const ABOUT_ME_PATH = "/o-mnie";

export const ABOUT_ME_SECTIONS = [
  { id: "profil", labelKey: "amNavProfile" },
  { id: "sukcesy", labelKey: "amNavSuccess" },
  { id: "doswiadczenie", labelKey: "amNavIndustries" },
  { id: "dzialalnosc-publiczna", labelKey: "amNavPublic" },
  { id: "sport-csr", labelKey: "amNavSport" },
];

export const ABOUT_ME_INDUSTRIES = [
  { id: "cyberbezpieczenstwo", icon: "🛡️", key: "amCyber", points: 3 },
  { id: "obronnosc", icon: "🎖️", key: "amDefence", points: 2 },
  { id: "finanse", icon: "📊", key: "amFinance", points: 2 },
  { id: "marketing", icon: "📈", key: "amMarketing", points: 5 },
  { id: "media", icon: "🎥", key: "amMedia", points: 3 },
  { id: "produkcja", icon: "⚙️", key: "amProduction", points: 3 },
  { id: "motoryzacja", icon: "🚗", key: "amAutomotive", points: 1 },
  { id: "erp", icon: "💼", key: "amErp", points: 2 },
  { id: "medtech-agrotech", icon: "⚕️", key: "amMedAgro", points: 2 },
];
